<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>
          <h5>Cadastro de Veículos</h5>
        </v-toolbar-title>
        <v-tabs
          v-model="active"
          show-arrows
          slot="extension"
          color="grey lighten-4"
          slider-color="black"
        >
          <v-tab key="1" ripple>Veículo</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:300px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO CODIGO -->
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="veiculo.id"
                      label="Código"
                      v-bind:disabled='true'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field v-model="veiculo.placa" label="Placa" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-text-field v-model="veiculo.modelo" label="Veículo" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-select v-model="veiculo.tipo" :items="itemss" label="Tipo" required></v-select>
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-select
                      :items="depto"
                      filled
                      v-model="veiculo.fk_depto"
                      item-text="descricao"
                      item-value="id"
                      label="Departamento"
                      @input="onDeptoSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-currency-field v-model="veiculo.kminicial" v-bind="currency_config" label="Km final"></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field v-model="veiculo.patrimonio" label="Patrimônio"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field v-model="veiculo.centro_custo" label="Centro de Custo"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/veiculo')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="salvar()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { showFlash, showError } from '@/utils'
import veiculoService from '@/services/veiculos'
import departamentosService from '@/services/departamentos'

export default {
  name: 'veiculo',
  data () {
    return {
      currency_config: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 0,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      item: {
        lanctto: ''
      },
      itemlancto: {
        descr: ''
      },
      tipo: {
        descr: ''
      },
      itemss: ['TRATOR', 'SEMI-REBOQUE'],
      resultado: {},
      veiculo: {},
      depto: [],
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      iddepto: 0
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      this.loading = true
      this.plano = {}
      this.depto = []
      const result = await departamentosService.getByAll()
      if (result.data !== undefined) {
        this.depto = result.data
      }
      if (id === undefined) {
        this.modo = 'I'
        this.loading = false
        return
      }
      this.modo = 'A'
      this.veiculo = await veiculoService.getById(id)
      this.loading = false
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  computed: {
    isAlterar: function () {
      return this.modo === 'A'
    }
  },
  methods: {
    async onDeptoSelect () {
      this.iddepto = this.veiculo.fk_depto
    },
    async salvar () {
      try {
        if (this.modo === 'A') {
          this.resultado = await veiculoService.savePut(this.veiculo)
          this.$router.push(`/veiculo`)
        } else {
          this.resultado = await veiculoService.savePost(this.veiculo)
          this.veiculo.placa = ''
          this.veiculo.modelo = ''
        }
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.flex{
    height: 60px;
  }
.e-data-table3 {
  background: red;
}
</style>
